<template>
  <div class="dashboard-container">
    <AccountMessages />
    <RabotaruTokenExpiredBar />
    <VSystemBar
      v-if="showSystemBar"
      height="53px"
      app
      fixed
      window
      :style="emailBarStyle"
      class="justify-center cyan lighten-5 text-center huntica-notification email-bar"
    >
      <VerifyEmailBar v-if="showVerifyEmailBar" />
    </VSystemBar>
    <PageTitle
      v-if="showDashboardTip"
      tag="h1"
      no-border
      :class="[
        'my-2 mt-4 mt-md-5 text-center text-md-left',
        { 'dashboard-title-without-card': !showDashboardCardTip },
      ]"
    >
      {{ $t('welcome') }}
    </PageTitle>
    <template v-if="showDashboardCardTip">
      <!-- TODO: Раскомментировать когда будет релиз интеграции HH -->
      <!-- <div v-if="showHHAuthBlockCondition" class="hh-auth-block">
        <VBtn
          icon
          small
          absolute
          top
          right
          @click="showHHAuthBlock = false"
          class="btn-close"
        >
          <IconClose />
        </VBtn>
        <div class="hh-auth-block--content d-flex align-center">
          <img
            :src="require('@/assets/img/hh-logo.svg')"
            class="mr-3"
            widht="32"
            height="32"
          />
          <p class="welcome-description">
            {{ $t('welcomeDescriptionPrefix') }}
            <a href="#" @click.prevent="handleHHAuthorization" class="hh-auth-link">
              {{ $t('welcomeDescriptionHHLink') }}
            </a>
            {{ $t('welcomeDescriptionSuffix') }}
          </p>
        </div>
      </div>
      <div v-else-if="showHHInfoBlockCondition" class="hh-info-block">
        <p class="welcome-description">
          {{ $t('welcomeDescription') }}
        </p>
      </div>
      <div v-if="showHHAuthErrorBlockCondition" class="hh-auth-error-block">
        <VBtn
          icon
          small
          absolute
          top
          right
          @click="showHHAuthErrorBlock = false"
          class="btn-close"
        >
          <IconClose />
        </VBtn>
        <p class="welcome-description d-flex align-center">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            class="mr-3"
          >
            <g opacity="0.5" clip-path="url(#clip0_8823_970)">
              <path d="M1.33333 28H30.6667L16 2.66666L1.33333 28ZM17.3333 24H14.6667V21.3333H17.3333V24ZM17.3333 18.6667H14.6667V13.3333H17.3333V18.6667Z" fill="#FF0000" />
            </g>
            <defs>
              <clipPath id="clip0_8823_970">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>

          {{ $t('hhAuthErrorPrefix') }}
          <img
            :src="require('@/assets/img/hh-logo.svg')"
            widht="20"
            height="20"
            class="mx-1"
          />
          <span class="mr-1">{{ $t('hhAuthErrorLinkTry') }}</span>
          <a href="#" @click.prevent="handleHHAuthorization" class="hh-auth-link">
            {{ $t('hhAuthErrorLink') }}
          </a>
        </p>
      </div> -->
      <DashboardCard
        :company="company"
        :users="users"
        :class="{ 'mt-4': dashboardCardMarginTop }"
        @close="hideDashboardCardTip"
      />
    </template>
    <VRow no-gutters class="align-stretch">
      <VCol cols="12" lg="6">
        <QuotaLeft />
      </VCol>
      <VCol cols="12" lg="6">
        <DashboardAdvice />
      </VCol>
    </VRow>
    <div class="my-12">
      <PageTitle tag="h2">
        {{ $t('interviews') }}
      </PageTitle>
      <template v-if="vacancies.length > 0">
        <VacancyCandidatesKanban
          v-show="false"
          v-if="chosenVacancy"
          :vacancy="chosenVacancy"
          :candidates="chosenVacancyCandidates"
        />
        <VRow>
          <VCol
            class="d-flex pr-md-3 pl-3"
          >
            <button
              class="dashboard__interview-button"
              color="success"
              @click.stop="openCreateVideoCallDialog"
            >
              {{ $t('recordVideoCall') }}
              <span class="dashboard__interview-hint">{{ $t('createVideoCallDescription') }}</span>
            </button>
            <button
              color="success"
              @click.stop="openCreateOfficeInterviewDialog"
              class="dashboard__interview-button"
            >
              {{ $t('recordOfficeInterview') }}
              <span class="dashboard__interview-hint">
                {{ $t('recordOfficeInterviewDescription') }}
              </span>
            </button>
          </VCol>
        </VRow>
      </template>
      <Preloader v-if="candidatesWithNewInterviewFetchingStatus.isFetching" />
      <VRow v-else-if="candidatesWithNewInterviewFetchingStatus.fetchError">
        <VCol cols="12">
          <VAlert type="error">
            {{ candidatesWithNewInterviewFetchingStatus.fetchError }}
          </VAlert>
        </VCol>
      </VRow>
      <p
        v-else-if="candidatesWithNewInterview.length === 0"
        class="font-weight-thin"
      >
        {{ $t('noInterviews') }}
      </p>
      <CandidateBigSlider
        v-else
        :candidates="candidatesWithNewInterview"
      />
    </div>

    <PageTitle
      tag="h2"
      class="mb-2"
    >
      {{ $t('vacancies') }}
    </PageTitle>

    <VRow>
      <VCol cols="12">
        <Preloader v-if="loadingVacancies" />
        <VRow v-else-if="vacanciesErrorMessage">
          <VCol cols="12">
            <VAlert type="error">
              {{ vacanciesErrorMessage }}
            </VAlert>
          </VCol>
        </VRow>
        <div v-else>
          <div class="mb-7">
            <VacancyStoreButton />
            <IntegrationsVacancyImportDialog />
          </div>
          <VacancyTable
            :company="company"
            :vacancies="vacancies"
            :select-data="selectData"
            :selected-users="selectedUsers"
            @fetch="fetchVacancies($event)"
            @clearSelectedUsers="clearSelectedUsers"
            class="dashboard-vacancy-table"
          />
        </div>
      </VCol>
    </VRow>
    <VDialog
      v-model="createInterviewDialog"
      max-width="600"
    >
      <VCard>
        <DialogHeader
          :title="$t('chooseVacancy')"
          text-class="black--text"
          @close="closeCreateInterviewDialog"
        />
        <Preloader v-if="candidatesLoading" />
        <VForm v-show="!candidatesLoading" class="popup__form">
          <VRow>
            <VCol>
              <VSelect
                v-model="chosenVacancy"
                item-text="title"
                return-object
                outlined
                dense
                style="width: 100%"
                :label="$t('chooseVacancy')"
                :items="vacancies"
              />
            </VCol>
          </VRow>
          <VRow>
            <VCol>
              <VBtn
                @click.stop="closeCreateInterviewDialog"
              >
                {{ $t('cancel') }}
              </VBtn>
            </VCol>
          </VRow>
        </VForm>
      </VCard>
    </VDialog>
  </div>
</template>

<script>
import IntegrationsVacancyImportDialog from '@/components/Integrations/IntegrationsVacancyImportDialog';
import QuotaLeft from '@/components/Payment/Quota/QuotaLeft';
import AccountMessages from '@/components/Payment/Misc/AccountMessages';
import RabotaruTokenExpiredBar from '@/components/RabotaruTokenExpiredBar';
import { ref } from '@vue/composition-api';
import useUser from '@/compositions/useUser';
import useKanbanDialogs from '@/compositions/useKanbanDialogs';
import useSubscription from '@/compositions/accounting/useSubscription';
import useHHIntegration from '@/compositions/useHHIntegration';
import DialogHeader from '@/components/DialogHeader';
import VerifyEmailBar from '@/components/VerifyEmailBar';
import IconClose from '@/components/SvgIcons/Close.vue';
import { candidateInterviewType, candidatePhotoType, interviewStatusType } from '../enums';
import ValidationMixin from '../mixins/ValidationMixin';
import DashboardCard from '../components/Dashboard/DashboardCard.vue';
import VacancyTable from '../components/Vacancy/VacancyTable.vue';
import PageTitle from '../components/PageTitle.vue';
import CandidateBigSlider from '../components/Candidate/CandidateBigSlider.vue';
import Preloader from '../components/Preloader.vue';
import Vacancy from '../orm/models/Vacancy/Vacancy';
import Candidate from '../orm/models/Candidate/Candidate';
import CompanySettings from '../orm/models/Company/Settings';
import DashboardAdvice from '../components/Dashboard/DashboardAdvice';
import VacancyStoreButton from '../components/Vacancy/VacancyStoreButton';
import VacancyCandidatesKanban from '../components/Vacancy/VacancyCandidatesKanban.vue';
import { shouldShowHHIntegration } from '../helpers/constants';

export default {
  name: 'Dashboard',
  metaInfo() {
    return {
      title: this.$t('panel'),
    };
  },
  components: {
    DialogHeader,
    IconClose,
    RabotaruTokenExpiredBar,
    AccountMessages,
    QuotaLeft,
    IntegrationsVacancyImportDialog,
    VacancyStoreButton,
    DashboardAdvice,
    Preloader,
    CandidateBigSlider,
    PageTitle,
    DashboardCard,
    VacancyTable,
    VacancyCandidatesKanban,
    VerifyEmailBar,
  },
  mixins: [ValidationMixin],
  props: {
    company: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { users, getUsers } = useUser();
    const {
      recordOfficeInterviewDialog,
      createVideoCallDialog,
    } = useKanbanDialogs();
    const { isExpired } = useSubscription();
    const hhIntegration = useHHIntegration();
    const showDashboardTip = ref(false);
    const showDashboardCardTip = ref(false);
    const isHHIntegrationDataLoaded = ref(false);
    const showHHAuthBlock = ref(true);
    const showHHAuthErrorBlock = ref(true);

    async function handleHHAuthorization() {
      await hhIntegration.handleAuthorization(this.$router);
    }

    return {
      users,
      getUsers,
      recordOfficeInterviewDialog,
      createVideoCallDialog,
      isExpired,
      handleHHAuthorization,
      hhIntegration,
      isHHAuthorized: hhIntegration.isAuthorized,
      isHHIntegrationDataLoaded,
      showDashboardTip,
      showDashboardCardTip,
      showHHAuthBlock,
      showHHAuthErrorBlock,
      shouldShowHHIntegration: shouldShowHHIntegration(),
    };
  },
  data() {
    return {
      loadingVacancies: true,
      vacanciesErrorMessage: null,
      selectedUsers: [],
      chosenVacancy: null,
      chosenVacancyCandidates: [],
      createInterviewDialog: false,
      candidatesLoading: false,
      createInterviewType: null,
    };
  },
  computed: {
    candidatesWithNewInterview() {
      return Candidate.query()
        .where('isNew', true)
        .with('vacancy')
        .with('photos')
        .orderBy('interviewedAt', 'desc')
        .get();
    },
    candidatesWithNewInterviewFetchingStatus() {
      return Candidate.getFetchStatus('candidates_with_new_interviews');
    },
    vacancies() {
      if (this.company) {
        return Vacancy.scopes
          .notArchivedVacancies()
          .where('companyId', this.company.id)
          .with('address')
          .get();
      }

      return Vacancy.scopes
        .notArchivedVacancies()
        .with('address')
        .get();
    },
    selectData() {
      if (!this.users) {
        return [];
      }

      return this.users.filter((user) => {
        return user.hasActiveVacancies;
      }).map((user) => {
        user.fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim();

        if (!user.position) {
          return user;
        }

        user.fullName = `${user.fullName}, ${user.position}`;

        return user;
      });
    },
    showSystemBar() {
      return this.showVerifyEmailBar;
    },
    showVerifyEmailBar() {
      return this.user && !this.user.emailVerified;
    },
    emailBarStyle() {
      const isMobile = this.$vuetify.breakpoint.xs;
      const style = {
        zIndex: 10,
        top: isMobile ? '60px' : '0',
      };
      if (isMobile) {
        style.marginTop = '0';
      }
      return style;
    },
    showHHAuthBlockCondition() {
      return this.isHHIntegrationDataLoaded
        && !this.isHHAuthorized
        && this.showHHAuthBlock
        && this.shouldShowHHIntegration;
    },
    showHHInfoBlockCondition() {
      return this.shouldShowHHIntegration
        && (!this.isHHIntegrationDataLoaded || !this.isHHAuthorized)
        && !this.showHHAuthErrorBlockCondition
        && !this.showHHAuthBlockCondition;
    },
    showHHAuthErrorBlockCondition() {
      return this.isHHIntegrationDataLoaded
        && this.hhIntegration.integrationData?.authNeeded === true
        && this.showHHAuthErrorBlock
        && this.shouldShowHHIntegration;
    },
    dashboardCardMarginTop() {
      return !this.shouldShowHHIntegration
        || (this.isHHIntegrationDataLoaded && !this.isHHAuthorized && this.showHHAuthBlock);
    },
  },
  watch: {
    async chosenVacancy(newValue) {
      if (!newValue) {
        return;
      }

      await this.fetchCandidatesForVacancy();
    },
    'company.settings.showDashboardTip': {
      immediate: true,
      handler(value) {
        this.showDashboardCardTip = value !== false;
      },
    },
  },
  async beforeMount() {
    if (this.user.createdUid) {
      await this.$router.push({ name: 'logout' });
      return;
    }
    this.showDashboardTip = true;

    await Promise.all([
      this.fetchCandidatesWithNewInterview(),
      this.fetchVacancies(),
      this.getUsers(),
      this.hhIntegration.fetchIntegrationData().then(() => {
        this.isHHIntegrationDataLoaded = true;
      }),
    ]);
  },
  methods: {
    async fetchCandidatesWithNewInterview() {
      await Candidate.api().fetchAllByCompanyId(this.company.id, {
        interview: {
          statuses: [interviewStatusType.READY],
          viewed: false,
        },
      }, {
        column: 'interview.created_at',
        direction: 'desc',
      }, candidatePhotoType.W300, 'candidates_with_new_interviews');
    },
    async fetchVacancies(data = []) {
      this.selectedUsers = data;
      await this.withApiErrorHandling(async () => {
        if (this.selectedUsers.length > 0) {
          Vacancy.query().deleteAll();
          await Vacancy.api().fetchByCompanyIdAndUsers(
            this.company.id,
            { selectedUsers: this.selectedUsers },
          );
        } else {
          await Vacancy.api().fetchAllByCompanyId(
            this.company.id,
          );
        }
      }, (e) => {
        this.vacanciesErrorMessage = e.message;
      }, 'loadingVacancies');
    },
    async fetchCandidatesForVacancy() {
      this.candidatesLoading = true;
      try {
        await Candidate.api().fetchAllByVacancyId(this.chosenVacancy.id, candidatePhotoType.S50);
      } catch (e) {
        this.candidatesLoading = false;
        throw e;
      }

      this.chosenVacancyCandidates = Candidate.query()
        .with('photos')
        .where('vacancyId', this.chosenVacancy.id)
        .orderBy((candidate) => candidate.interviewedAt ?? candidate.createdAt, 'desc')
        .get();

      this.candidatesLoading = false;
      this.createInterviewDialog = false;

      switch (this.createInterviewType) {
        case candidateInterviewType.VIDEO_CALL: {
          this.createVideoCallDialog = true;
          break;
        }
        case candidateInterviewType.OFFICE_INTERVIEW: {
          this.recordOfficeInterviewDialog = true;
          break;
        }
        default: {
          break;
        }
      }
    },
    closeCreateInterviewDialog() {
      this.createInterviewDialog = false;
      this.candidatesLoading = false;
      this.chosenVacancy = null;
      this.chosenVacancyCandidates = [];
      this.createInterviewType = null;
    },
    openCreateVideoCallDialog() {
      this.closeCreateInterviewDialog();
      this.createInterviewType = candidateInterviewType.VIDEO_CALL;
      this.createInterviewDialog = true;
    },
    openCreateOfficeInterviewDialog() {
      this.closeCreateInterviewDialog();
      this.createInterviewType = candidateInterviewType.OFFICE_INTERVIEW;
      this.createInterviewDialog = true;
    },
    clearSelectedUsers() {
      this.selectedUsers = [];
    },
    async hideDashboardCardTip() {
      this.showDashboardCardTip = false;
      await CompanySettings.api().update(this.company.id, { showDashboardTip: false });
    },
  },
};
</script>

<style lang="scss" scoped>
  .dashboard-vacancy-table {
    background: #FFFFFF;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    padding: 43px 30px 18px;
    font-size: 0.75rem;
    line-height: 1.33;
    color: #212121;
  }

  .dashboard {
    &__interview-button {
      margin-right: 20px;
      margin-bottom: 0;
      position: relative;
      padding: 8px 16px;
      background: #1FC57F;
      border-radius: 5px;
      color: white;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.24);
      font-size: 14px;
      &:hover {
        .dashboard__interview-hint {
          z-index: 2;
          opacity: 1;
          background: rgba(243, 243, 243, 1.0);
          height: auto;
          transition: all 0.3s;
        }
      }
    }

    &__interview-hint {
      color: black;
      opacity: 0;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 5px;
      display: block;
      pointer-events: none;
      position: absolute;
      top: calc(100% + 15px);
      left: 0;
      width: 424px;
      height: 0;
      background: rgba(243, 243, 243, 1.0);
      z-index: 0;
      padding: 12px;
      text-align: left;
      &:before {
        content: '';
        z-index: -1;
        width: 14px;
        height: 14px;
        position: absolute;
        top: -5px;
        left: 15px;
        background: #f3f3f3;
        transform: rotate(45deg);
      }

      @media (max-width: 400px) {
        width: 360px;
        left: -5px;
      }
    }
  }

  .popup__form {
    padding: 20px;
    /* overflow: hidden; */
    .row {
      margin: 0;
    }
  }

  .dashboard-title-without-card {
    margin-bottom: 20px !important;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .dashboard-vacancy-table {
      padding: 0 10px;
    }
  }

  @media (max-width: 599px) {
    .email-bar.v-system-bar {
      margin-top: 0 !important;
    }
  }

  .hh-auth-block,
  .hh-info-block,
  .hh-auth-error-block {
    position: relative;
    padding: 30px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
    background: #FFFFFF;
    border-radius: 10px;
    margin-bottom: 1rem;
    margin-top: 20px;

    .btn-close {
      z-index: 2;
    }
  }

  .hh-info-block {
    display: flex;
    align-items: center;
  }

  .hh-auth-error-content {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
  }

  .hh-auth-error-text-block {
    flex: 1;
    min-width: 0;
  }

  .hh-auth-error-link-block {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-shrink: 0;
  }

  .hh-logo-icon {
    width: 120px;
    height: 60px;
    flex-shrink: 0;
  }

  .welcome-description {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    margin: 0;
    max-width: 78%;
  }

  @media screen and (max-width: 1240px) {
    .hh-auth-error-content {
      flex-direction: column;
      align-items: flex-start;
    }

    .hh-auth-error-text-block {
      width: 100%;
    }

    .hh-auth-error-link-block {
      width: 100%;
    }

    .welcome-description {
      max-width: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    .hh-auth-block,
    .hh-info-block,
    .hh-auth-error-block {
      padding: 20px;
    }

    .welcome-description {
      max-width: 95%;
    }

    .hh-logo-icon {
      width: 100px;
      height: 50px;
    }
  }

  @media screen and (max-width: 450px) {
    .welcome-description {
      max-width: 90%;
    }
  }

  .hh-auth-link {
    color: #0a82d9;
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      color: #0868b3;
    }
  }

</style>

<i18n locale="en" lang="yaml">
  welcome: Welcome to Huntica!
  welcomeDescription: You can log in to HeadHunter and import all information about your company, as well as data on vacancies and candidates. Or fill in information about the company and create vacancies manually.
  welcomeDescriptionPrefix: You can
  welcomeDescriptionHHLink: log in to HeadHunter
  welcomeDescriptionSuffix: and import all information about your company, as well as data on vacancies and candidates. Or fill in information about the company and create vacancies manually.
  hhAuthErrorPrefix: HeadHunter authorization error.
  hhAuthErrorLinkTry: Try to
  hhAuthErrorLink: authorize again
  panel: Dashboard
  interviews: Interviews
  noInterviews: There are no new interviews to view
  vacancies: Jobs
  selectUserLabel: Select user
  recordVideoCall: Record video call
  recordOfficeInterview: Record in-person interview
  chooseVacancy: Choose job
  cancel: Cancel
  createVideoCallDescription: By clicking on the "Record video call" button, you can conduct and record an online meeting (just like in Zoom).
    The recording can be shared with colleagues who could not personally participate.
  recordOfficeInterviewDescription: By clicking on the "Record in-person interview" button, you can conduct and record an interview in the office.
    The recording can be shared with colleagues who could not personally participate.
</i18n>

<i18n locale="ru" lang="yaml">
  welcome: Добро пожаловать в Huntica!
  welcomeDescription: Вы можете авторизоваться на HeadHunter и импортировать всю информацию о вашей компании, а также данные по вакансиям и кандидатам. Или заполнить информацию о компании и создать вакансии вручную.
  welcomeDescriptionPrefix: Вы можете
  welcomeDescriptionHHLink: авторизоваться на HeadHunter
  welcomeDescriptionSuffix: и импортировать всю информацию о вашей компании, а также данные по вакансиям и кандидатам. Или заполнить информацию о компании и создать вакансии вручную.
  hhAuthErrorPrefix: Ошибка авторизации на HeadHunter.
  hhAuthErrorLinkTry: Попробуйте
  hhAuthErrorLink: авторизоваться повторно
  panel: Панель
  interviews: Интервью
  noInterviews: Нет новых интервью для просмотра
  vacancies: Вакансии
  selectUserLabel: Выберите пользователя
  recordVideoCall: Записать видеозвонок
  recordOfficeInterview: Записать очное интервью
  chooseVacancy: Выберите вакансию
  cancel: Отмена
  createVideoCallDescription: Нажав на кнопку видеозвонок, вы сможете провести и записать онлайн-встречу (как в Zoom). Записью можно будет поделиться с коллегой, который не смог лично поучаствовать.
  recordOfficeInterviewDescription: Нажав на кнопку записать офисное интервью, вы сможете провести и записать собеседование в офисе. Записью можно будет поделиться с коллегой, который не смог лично поучавствовать.
</i18n>
